module.exports = __webpack_public_path__ + "static/media/uspp-logo.aafe2dcc.png";